import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-wage-view-toggle",
  role: "group",
  "aria-label": "급여 표시 시점"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWagePayrollViewToggle',
  props: {
    directorActive: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["home-wage-view-toggle__btn", { 'home-wage-view-toggle__btn--active': __props.directorActive }]),
      disabled: __props.disabled,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('select', 'director')))
    }, " 센터장 ", 10, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["home-wage-view-toggle__btn", { 'home-wage-view-toggle__btn--active': !__props.directorActive }]),
      disabled: __props.disabled,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('select', 'admin')))
    }, " 관리자 ", 10, _hoisted_3)
  ]))
}
}

})